import { makeStyles } from '@material-ui/core/styles';

export const useDetailStyles = makeStyles((theme) => ({
    usageSelect: {
        '& .MuiSelect-select': {
            width: 400,
        },
    },

    associationSelect: {
        '& .MuiSelect-select': {
            width: 400,
        },
    },
    fileUpload: {
        paddingTop: '15px',
        alignItems: 'center',
        gridGap: '20',
    },
    helpText: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    uploadStatus: {
        display: 'inline-flex',
        alignItems: 'flex-start',
        marginLeft: theme.spacing(0.25),
        marginTop: theme.spacing(0.15),
        padding: theme.spacing(0.75, 0),
    },
    uploadProgress: {
        marginBottom: theme.spacing(1),
    },
    failure: {
        '& .MuiSvgIcon-root': {
            fontSize: '20px',
            marginRight: theme.spacing(0.5),
            color: '#b97c7c',
        },
    },
    success: {
        '& .MuiSvgIcon-root': {
            fontSize: '20px',
            marginRight: theme.spacing(0.5),
            color: '#8bad93',
        },
    },
    dashedBox: {
        flex: 1,
        borderBottom: '1px dashed #c4c4c4',
        borderRadius: 4,
        padding: theme.spacing(1.5),
        color: '#666',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    hiddenInput: {
        display: 'none',
    },
    uploadFeedback: {
        maxHeight: '400px',
        overflow: 'auto',
        padding: '10px',
    },
}));
